import React, { useContext, useState } from 'react'
import Stack from '@mui/material/Stack'
import LogsComponent from '../../../../components/Logs/LogsComponent'
import { SectionHeader } from '../../vehicles/VehicleComponents/SectionKit'
import { AssetContext } from './SingleAsset'

// Free-text notes plus the audit trail the server appends on check in/out,
// vehicle moves and edits.
const NotesSection = () => {
  const { asset } = useContext(AssetContext)
  const [openComment, setOpenComment] = useState(false)
  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Notes"
        caption="Notes and activity recorded against this asset"
      />
      <LogsComponent
        targetId={asset._id}
        targetType="asset"
        hideTitle
        allowCreateLog
        openComment={openComment}
        setOpenComment={setOpenComment}
      />
    </Stack>
  )
}

export default NotesSection
